"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useAnimation = _interopRequireDefault(require("../../hooks/useAnimation"));
var _useDidValueChanged = _interopRequireDefault(require("../../hooks/useDidValueChanged"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../hooks/useIsomorphicLayoutEffect"));
var _useMeasure = _interopRequireDefault(require("../../hooks/useMeasure"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Collapsible = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props.open,
    open = _a === void 0 ? false : _a,
    children = props.children,
    rest = __rest(props, ["open", "children"]);
  var trackFromHeight = (0, _react.useRef)(0);
  var transitioning = (0, _react.useRef)(false);
  var initialValue = (0, _react.useRef)(open);
  var wrapperRef = (0, _react.useRef)(null);
  var _b = (0, _react.useState)(null),
    contentRef = _b[0],
    setContentRef = _b[1];
  var heightTransition = (0, _useAnimation.default)().heightTransition;
  var observeElementRect = (0, _useMeasure.default)(contentRef).rect;
  var observeElementHeight = observeElementRect.height;
  var toggle = (0, _useDidValueChanged.default)({
    observeElementHeight: observeElementHeight,
    open: open
  }, function (prev, curr) {
    // Check if a default open value is set to true.
    if (initialValue.current && curr.observeElementHeight > 0) {
      initialValue.current = false;
      return false;
    }
    return prev.open === curr.open;
  });
  (0, _useIsomorphicLayoutEffect.default)(function () {
    if (toggle && wrapperRef.current) {
      transitioning.current = true;
      var from = open ? trackFromHeight.current : observeElementHeight;
      var to = open ? observeElementHeight : 0;
      trackFromHeight.current = to;
      heightTransition({
        element: wrapperRef.current,
        from: from,
        to: to,
        onComplete: function onComplete() {
          transitioning.current = false;
        }
      });
    }
  }, [toggle, heightTransition, observeElementHeight, open]);
  (0, _react.useEffect)(function () {
    if (open && !transitioning.current) {
      var wrapperElement = wrapperRef.current;
      var from = trackFromHeight.current;
      var to = observeElementHeight;
      trackFromHeight.current = to;
      heightTransition({
        element: wrapperElement,
        from: from,
        to: to
      });
    }
  }, [heightTransition, observeElementHeight, open, children]);
  return (0, _jsxRuntime.jsx)(Styled.Container, __assign({
    ref: ref
  }, rest, {
    children: (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({
      ref: wrapperRef
    }, {
      children: (0, _jsxRuntime.jsx)(Styled.ContentWrapper, __assign({
        ref: setContentRef
      }, {
        children: children
      }))
    }))
  }));
});
Collapsible.displayName = "Collapsible";
var _default = Collapsible;
exports.default = _default;